export const article = {
  id: 11,
  title: "রাজদরবার",
  slug: "raj-dorbar",
  date: "February 2, 2025",
  excerpt: `"সত্য সৌন্দর্য ইত্যাদি যা কিছু মানুষকে মন থেকে টানে, যা কিছু মানুষকে নিজের চারদিকের সংকীর্ণ জগৎ থেকে বেরিয়ে আসার আহ্বান জানায়, \"নাথ\" এখানে তার প্রতীক।" রবীন্দ্রনাথের 'রাজা' নাটক অনুপ্রাণিত এক আত্মিক যাত্রার গল্প।`,
  content: `রবীন্দ্রনাথ ঠাকুরের *রাজা* নাটকে "নাথ" যে মুক্তির প্রতীক—রাজদরবারের পছন্দসই সীমার ভিতরে আটকে থাকা মানুষকে যে অনন্তের দিকে ডাক দেয়—এই নিবন্ধ সেই সুরের অনুসন্ধান। "সত্য সৌন্দর্য ইত্যাদি যা কিছু মানুষকে মন থেকে টানে, যা কিছু মানুষকে নিজের চারদিকের সংকীর্ণ জগৎ থেকে বেরিয়ে আসার আহ্বান জানায়, \"নাথ\" এখানে তার প্রতীক।"

## নাটক ও নাথের প্রতীক

নাটকের ভিতরে রাজদরবার আসলে এক অন্তর্গত গুহা, যেখানে প্রত্যেকে নিজের অভ্যাস, ভয় আর স্বার্থের বাঁধনে বাঁধা। নাথ সেখানে পরম স্বাধীনতার কণ্ঠস্বর। যে মানুষকে ছাপোষা আকাঙ্ক্ষা, ক্ষমতার মোহ কিংবা ভয়ের গণ্ডি ভেঙে বাইরে আসতে আমন্ত্রণ জানায়। নাথ মানে সেই চূড়ান্ত আহ্বান—যেখানে সত্য, সৌন্দর্য আর প্রেম একই সঙ্গে মানুষকে আলোয় ফেরত নিয়ে আসে।

## কবিতা: রাজদরবারের আর্তি

<pre>
কোথা যাই বল,    না যদি হে, ডাকো;
রাজ দরবারে    তব;
আমি হেথা, নাথ;    কত কাল বলো;
আঁধারে    ডুবিয়া রবে?
কামনা বাসনা; সকল প্রকাশ;   ছলনা,
করিলে ঘিরে চারিধারা।
কর্ম ধর প্রভল আকর, বাঁধিলে জীবন,
ভূমির    উপরা।
যে সুখা সাগরে,   টানিল স্বপীরে;
সারাটা জীবন   ধরা।
নিয়া না তাহারে,   ফেলোনা আমাদের,
একাএই সংসারে।
দিনের অন্তে,    দাও গো, সুদূরে,
তোমার  ভবনে ঠাঁই।
ভাঙা ভাঙা স্বরে,   গেয়ে যাব গান,
যতটুকু শিখেছি তাই।।
</pre>

এই কবিতাটি রাজদরবারের আবদ্ধতা ও মুক্তির চাওয়ার সংলাপ। কক্ষের ভিতরে থাকা সকলেই নাথকে ডাকে—কারও কণ্ঠে আকুলতা, কারও কণ্ঠে ভয়। কিন্তু সবার মনের ভিতরে একটাই আকাঙ্ক্ষা: "এই আঁধার থেকে যদি নাথ ডাকে, তবে কি আমরা মুক্ত হব না?"

## আত্মিক মুক্তির নির্দেশ

নাটকের রাজার শূন্য সিংহাসন, ভৃত্যদের দ্বিধা এবং প্রজাদের অপেক্ষা—সব মিলিয়ে রাজদরবার আসলে মানুষের চেতনার অর্গল। নাথ এখানে সেই সত্তা, যে বলে: "বাঁধা কেন? সত্যের দিকে সরে যাও।" রাজদরবারের সীমানা ছাড়িয়ে যতটুকু হাঁটতে পারি, ততটাই কাছাকাছি যাই মুক্ত আনন্দের।

শনাক্ত করার মতো একটি মুহূর্ত আসে যখন আমরা বুঝতে পারি, যে কোনো বাহ্যিক বন্দনা নয়, অন্তরের জাগরণই আসল মুক্তির পথ। তখনই কবিতার শেষ লাইন আমাদের মনে করিয়ে দেয়: যতটুকু শিখেছি, তত আলো নিয়েই গান গাইতে হবে। নাথের দিকে এগোনো মানে প্রতিদিনকার জীবনের সাধারণ ক্লান্তিকে অতিক্রম করে অন্তরের গান শোনার সাধনা।

রাজদরবার—এই নিবন্ধের নাম যেমন, ঠিক তেমনি আমাদের প্রত্যেকের ভিতরের গোলচত্ত্বর। সেখান থেকে যদি আমরা নাথকে সত্যি ডাকতে পারি, তাহলে হয়তো সেই আলোই আমাদের শিখিয়ে দেবে মুক্তির গান।`,
  author: "সৌরভ রায়",
  readTime: "৬ মিনিট পড়া",
  category: "Arts",
  tags: ["রবীন্দ্রনাথ", "নাটক", "কবিতা", "আত্মদর্শন"],
  language: "bengali" as const
};
